import { usePublishedData } from "../lib/published-data";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import servicesStyles from "../styles/services.css?url";
import { DocumentContent } from "../components/document-content";
import { CoachingContent } from "../components/services/coaching";
import { useShell } from "../lib/document-route";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadCoaching } from "../server/services";

/** Coaching (/coaching): the page the creator composed, with the calendar at its built-in block, or the native page. */
export const Route = createFileRoute("/coaching/")({
  loader: async () => {
    const data = await loadCoaching();
    if (data.kind === "missing") throw notFound();
    if (data.kind === "redirect") throw redirect({ href: data.to, statusCode: 302 });
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head =
      loaderData.kind === "page"
        ? creatorPageHead(shell, {
            pathname: "/coaching",
            title: loaderData.page.seoTitle || loaderData.page.title,
            description: loaderData.page.description,
            noindex: loaderData.private || loaderData.locked || loaderData.page.hideFromSearch,
            preloadImage: loaderData.lead,
          })
        : creatorPageHead(shell, {
            pathname: "/coaching",
            title: `${loaderData.coaching.navTitle} | ${shell.creator.name}`,
            description:
              loaderData.coaching.intro || `Book a coaching session with ${shell.creator.name}.`,
          });
    return withStylesheet(head, servicesStyles);
  },
  component: Coaching,
});

function Coaching() {
  const initial = Route.useLoaderData();
  const shell = useShell();
  const { data } = usePublishedData(initial, shell, "/coaching", "page");
  const content = <CoachingContent coaching={data.coaching} />;
  return data.kind === "page" ? (
    <DocumentContent data={data} shell={shell} builtIn={content} />
  ) : (
    content
  );
}
